import { predefinedDateRanges } from '../DateRanges.utils';
import { useDateRange } from '../DateRanges.context';

const IsShortcutSelected = () => {
  const { dateRange } = useDateRange();
  const selected = predefinedDateRanges.find(
    range => range.value[0].isSame(dateRange[0]) && range.value[1].isSame(dateRange[1])
  );
  return selected;
};

export default IsShortcutSelected;
